import MLoadingButton from "@mui/lab/LoadingButton";
import MGrid from "@mui/material/Grid";
import { styled } from "@mui/material/styles";
import { colors } from "@zapalacorp/tokens";

export const InventoryCard = styled(MGrid)(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  position: "relative",
  borderRadius: "12px",
  backgroundColor: theme.palette.secondary.main,
  padding: "8px 8px 16px 16px",
}));

export const InventoryTitle = styled("span")({
  color: colors.gray600,
  fontFamily: "Manrope",
  fontSize: "16px",
  fontWeight: 600,
  lineHeight: "24px",
  letterSpacing: "0.15px",
});
export const InventoryType = styled("span")({
  color: colors.gray600,
  fontFamily: "Manrope",
  fontSize: "14px",
  fontWeight: 600,
  lineHeight: "20px",
  letterSpacing: "0.1px",
  marginRight: "4px",
});
export const InventoryValue = styled("span")({
  color: colors.gray600,
  fontFamily: "Manrope",
  fontSize: "14px",
  fontWeight: 400,
  lineHeight: "20px",
  letterSpacing: "0.25px",
  marginRight: "4px",
});
export const InventoryRedirect = styled(MLoadingButton)(({ theme }) => ({
  color: theme.palette.primary.main,
  fontFamily: "Manrope",
  fontSize: "14px",
  fontWeight: 600,
  lineHeight: "20px",
  letterSpacing: "0.1px",
  cursor: "pointer",
  padding: "10px 12px",
  textTransform: "none",
  "& svg": {
    position: "relative",
    top: "-1px",
  },
}));
